//#region IMPORT
import React, { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import {
  getAutoGroupColumnDef1,
  getColumnDefs1,
} from './PPE_BASIC_04_ColumnDefs';
//#endregion

function PPE_BASIC_04(props) {
  const searchInfo = useSelector((state) => state.SearchInfo);
  const gridRef1 = useRef();
  const columnDefs1 = useMemo(() => getColumnDefs1(), []);
  const autoGroupColumnDef = useMemo(() => getAutoGroupColumnDef1(), []);
  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick4) {
      if (!props.validateSelection()) {
        props.setFilterClick4(false);
        return;
      }

      gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick4(false);
    }
    if (props.searchClick4) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick4(false);
        return;
      }

      props.SearchLogic1();
      props.setSearchClick4(false);
    }
    if (props.addClick4) {
      if (!props.validateSelection()) {
        props.setAddClick4(false);
        return;
      }

      props.setAddClick4(false);
    }
    if (props.saveClick4) {
      if (!props.validateSelection()) {
        props.setSaveClick4(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick4(false);
    }
    if (props.deleteClick4) {
      if (!props.validateSelection()) {
        props.setDeleteClick4(false);
        return;
      }

      props.DeleteLogic1();
      props.setDeleteClick4(false);
    }
    if (props.printClick4) {
      if (!props.validateSelection()) {
        props.setPrintClick4(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick4(false);
    }
  }, [
    props.filterClick4,
    props.searchClick4,
    props.addClick4,
    props.saveClick4,
    props.deleteClick4,
    props.printClick4,
    props.listClick4,
  ]);
  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        addYn1="N"
        deleteYn1="N"
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        title1={'보호구 자가 체크 기록'}
        gridRef={gridRef1}
        editable={true}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        autoGroupColumnDef={autoGroupColumnDef}
      />
    </React.Fragment>
  );
}

export default PPE_BASIC_04;
